import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { IoAddOutline } from "react-icons/io5";
import { MdDeleteForever } from "react-icons/md";
import { AxiosResponse } from "axios";
import { Modal, Button } from "rsuite";
import { axiosGet, axiosPost } from "../../common/utils/helper";
import { EPInputNumber } from "../../common/controls/inputNumber";
import { EPSelectPicker } from "../../common/controls/selectPicker";
import { addRecruiters } from "../../common/utils/api";
import { toast } from "react-toastify";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import "./notificationModal.scss";
// import "./assignRecruitersModal.scss";
interface Props {
  open: boolean;
  setOpen: Function;
}

function NotificationsModal(props: Props) {
  const { open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} className="notification-modal">
        <Modal.Header closeButton={true}>
          <h6 className="dropdown-header d-inline-block align-top">
            Notification
          </h6>
          <span className="d-inline-block float-end me-2">3New</span>
        </Modal.Header>
        <Modal.Body>
          <ul className="notification-list">
            <li>
              <div className="notif-text">
                <span className="dark-color">Yogesh Shah</span> has raised the
                request for #001{" "}
                <span className="dark-color">Software engineer</span> in{" "}
                <span className="dark-color">.Net</span>
              </div>
              <div className="small text-gray-500">45min ago</div>
            </li>
            <li>
              <div className="notif-text">
                <span className="dark-color">Nirav Mevada</span> has raised the
                request for #002 <span className="dark-color">UI Designer</span>{" "}
                in Design skills
              </div>
              <div className="small text-gray-500">2 hours ago</div>
            </li>
            <li>
              <div className="notif-text">
                <span className="dark-color">Jigar Shah</span> has raised the
                request for #003{" "}
                <span className="dark-color">Node Develope</span> in{" "}
                <span className="dark-color">Open Source</span>
              </div>
              <div className="small text-gray-500">5 hours ago</div>
            </li>
            <li>
              <div className="notif-text">
                <span className="dark-color">Yogesh Shah</span> has raised the
                request for #001{" "}
                <span className="dark-color">Software engineer</span> in{" "}
                <span className="dark-color"> .Net</span>{" "}
              </div>
              <div className="small text-gray-500">25 hours ago</div>
            </li>
          </ul>

          {/* <div className="me-3">
            <div className="icon-circle bg-secondary">
              <HiOutlineMenuAlt1 color="white" />
            </div>
          </div> */}

          <Button
            type="button"
            className="btn btn-secondary float-start my-3 ms-3 px-4"
          >
            Clear all
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NotificationsModal;
